import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        Aluno: {},
        AbaQuadroHorario: {}
    },
    mutations: {
        setAluno(state, aluno) {
            state.Aluno = aluno;
        },

        populaAbaQuadroHorario(state, dadosAba) {
            state.AbaQuadroHorario = dadosAba;
        }
    }
})
